export default {
  en: {
    ENABLE_RTB_BTN_LABEL: 'Enable Real Time Bidding',
    RTB_INTRO: 'Dynamically bid on phone calls from your publishers based on the caller\'s information with Real Time Bidding.',
    RTB_INTRO_FOR_DISABLED_PUB: 'RTB is not enabled for this campaign.',
    PASSTHROUGH_INTRO_FOR_DISABLED_PUB: 'Pass Through is not enabled for this campaign. Enable it within the Real Time Bidding settings.',
    HEADER_DYNAMIC_INBOUND_CALLS: 'Real Time Bidding',
    HEADER_BID_DURATION_SETTINGS: 'Bid Expiration',
    HEADER_RATE_LIMIT: 'Rate Limit',
    HEADER_DEFAULT_BID_SETTINGS: 'Bid Settings',
    HEADER_DEFAULT_PASSTHROUGH_SETTINGS: 'Pass Through Settings',
    HEADER_BID_ADJUSTMENTS: 'Bid Modifiers',
    HEADER_CUSTOM_SCORING_SETTINGS: 'Custom Scoring',
    LABEL_ID: 'RTB Id',
    LABEL_DOCUMENTATION: 'RTB Documentation',
    LABEL_BUTTON_DOCUMENTATION: 'RTB Documentation',
    LABEL_ENABLED: 'Enabled',
    LABEL_ONLY_SIP: 'Only SIP',
    LABEL_REQUIRE_CALLER_ID: 'Require Caller ID',
    LABEL_ICP: 'Instant Caller Profiles',
    LABEL_JORNAYA_TCPA: 'Jornaya',
    LABEL_JORNAYA_CREDENTIALS: 'Jornaya Credentials',
    LABEL_TRUSTED_FORM: 'Trusted Form Cert ID',
    LABEL_TRUSTED_FORM_METHOD: 'Trusted Form Integration Method',
    LABEL_OVERRIDE_TRUSTED_FORM: 'Trusted Form Settings',
    LABEL_BID_GOOD_FOR: 'Bid Good For',
    LABEL_ROUTE_CALLS_FOR_STALE_BIDS: 'Stale Bid Behavior',
    LABEL_OVERRIDE_DEFAULT_BID_SETTINGS: 'Override Default Bid Settings',
    LABEL_MAXIMUM_REQUESTS: 'Maximum Requests',
    ERROR_MAXIMUM_REQUEST: 'The Maximum Requests must be a number and greater or equal to zero',
    MESSAGE_MAXIMUM_REQUEST: 'Requests from each publisher using default settings will be capped at {maxRequests} requests {period}.',
    MESSAGE_MAXIMUM_REQUEST_OVERRIDE: 'Requests from this publisher will be capped at {maxRequests} requests {period}.',
    MESSAGE_MAXIMUM_REQUEST_AFFILIATE: 'Requests will be capped at {maxRequests} requests {period}.',
    LABEL_OVERRIDE_RATE_LIMIT: 'Override Rate Limit Settings',
    LABEL_BASE_BID_AMOUNT: 'Base Bid Amount',
    LABEL_MAX_BID: 'Max Bid',
    LABEL_MIN_BID: 'Min Bid',
    LABEL_PAYOUT_ON: 'Payout On',
    LABEL_START_TIMER_EVENT: 'Start Call Length On',
    LABEL_LENGTH: 'Length',
    LABEL_DUPLICATE_PAYOUTS: 'Duplicate Payouts',
    LABEL_PAYOUT_HOURS: 'Payout Hours',
    LABEL_LIMIT_PAYOUT: 'Limit Payout',
    LABEL_OVERRIDE_DEFAULT_PASSTHROUGH_SETTINGS: 'Override Default Pass Through Settings',
    LABEL_OVERRIDE_BID_ADJUSTMENTS: 'Override Bid Adjustments',
    LABEL_PLACEHOLDER_BID_GOOD_FOR: '20',
    LABEL_PLACEHOLDER_MAXIMUM_REQUESTS: '10',
    LABEL_PLACEHOLDER_BASE_BID_AMOUNT: '$10',
    LABEL_PLACEHOLDER_MAX_BID: '$25',
    LABEL_PLACEHOLDER_MIN_BID: '$0',
    LABEL_PLACEHOLDER_LENGTH: '30',
    LABEL_ENABLE_PASSTHROUGH_SETTINGS: 'Enabled',
    LABEL_BID_MARGIN_PERCENTAGE: 'Bid Margin',
    LABEL_PLACEHOLDER_MIN_BID_MARGIN_PERCENTAGE: '%',
    LABEL_BID_MARGIN_AMOUNT: 'Bid Margin',
    LABEL_PLACEHOLDER_MIN_BID_MARGIN_AMOUNT: '$',
    LABEL_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS: 'Min Bid Margin After Adjustments',
    LABEL_PLACEHOLDER_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS: '%',
    LABEL_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS: 'Min Bid Margin After Adjustments',
    LABEL_PLACEHOLDER_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS: '$',
    LABEL_MIN_BID_DURATION_SELECTION: 'Min Call Duration for Payout',
    LABEL_MIN_BID_STATIC: 'Min Duration Override', 
    LABEL_MIN_BID_ADJUST: 'Duration Adjustment',
    LABEL_ALLOW_BIDS_AT_LOSS: 'Allow Bids at Loss',
    LABEL_PASS_THROUGH_TYPE: 'Bid Margin Type',
    LABEL_PERCENTAGE: 'Percentage',
    LABEL_AMOUNT: 'Amount',
    LABEL_BID_SETTINGS_OVERRIDE: 'Overridden by Pass Through settings',
    LABEL_TARGET_ROUTE_OVERRIDE: 'Overridden by Call Routing conversion settings',
    LABEL_CUSTOM_SCORING_TOGGLE: 'Custom Scoring',
    LABEL_CUSTOM_SCORING_TOGGLE_TT: 'Allows you to send and retrieve data from a 3rd-party endpoint provided by the buyer to be included in call details and used in bid modifiers.',
    LABEL_CUSTOM_SCORING_URL: 'URL',
    LABEL_CUSTOM_SCORING_URL_TT: 'URL to send the ping request to 3rd-party API endpoint.',
    LABEL_CUSTOM_SCORING_METHOD: 'Method',
    LABEL_CUSTOM_SCORING_METHOD_TT: 'HTTP Method to be used when sending the ping request to 3rd-party API endpoint.',
    LABEL_CUSTOM_SCORING_HEADERS: 'Headers',
    LABEL_CUSTOM_SCORING_HEADERS_TT: 'HTTP Headers to be used when sending the ping request to 3rd-party API endpoint.',
    LABEL_CUSTOM_SCORING_BODY: 'Request Body',
    LABEL_CUSTOM_SCORING_BODY_TT: 'Valid JSON to be used when sending the ping request to 3rd-party API endpoint.',
    LABEL_CUSTOM_SCORING_ACCEPTANCE_PARSING: 'Acceptance Parsing',
    LABEL_CUSTOM_SCORING_ACCEPTANCE_PARSING_TT: 'Configure the acceptance parsing pipeline to be applied to the ping response body to parse the value to be used as the RTB ping acceptance.',
    LABEL_CUSTOM_SCORING_SCORE_PARSING: 'Score Parsing',
    LABEL_CUSTOM_SCORING_SCORE_PARSING_TT: 'An optional parsing step to retrieve a tag that specifies a numerical score for the bid.',
    LABEL_CUSTOM_SCORING_CUSTOM_TAGS: 'Custom Tags',
    LABEL_CUSTOM_SCORING_CUSTOM_TAGS_TT: 'A list of tags supplied from a 3rd-party API endpoint that will be included in call details and can be used in bid modifiers.',
    TOOLTIP_ID: 'This is the id that must be used in all bid requests.',
    TOOLTIP_DOCUMENTATION: 'API documentation',
    TOOLTIP_COPY_BUTTON_ID: 'Click to copy your RTB Id.',
    TOOLTIP_ENABLED: 'Enables Real Time Bidding for all the publishers in this campaign.',
    TOOLTIP_ONLY_SIP: 'Only provides SIP numbers to be called.',
    TOOLTIP_REQUIRE_CALLER_ID: 'Requires the Caller ID to be passed in every ping.',
    TOOLTIP_ICP: `If enabled, ICP will be used to enrich the call for every ping that contains a caller ID.<br> If set to Required, no bid will be returned if the call didn't trigger ICP.`,
    TOOLTIP_JORNAYA_TCPA: 'If enabled, Ringba will check the Lead ID with Jornaya to verify its authenticity.<br> If required, Ringba will not return a bid unless a Lead ID was provided and authenticated.',
    TOOLTIP_JORNAYA_CREDENTIALS: 'Use the account settings, or override with custom Jornaya settings.',
    TOOLTIP_TRUSTED_FORM: 'If enabled, Ringba will claim the Cert ID with Trusted Form to verify its authenticity.<br> If required, Ringba will not return a bid unless a Cert ID was provided and authenticated.',
    TOOLTIP_TRUSTED_FORM_METHOD: 'The method Trusted From will authenticate the call.',
    TOOLTIP_OVERRIDE_TRUSTED_FORM: 'Use the account settings, or override with custom Trusted Form settings.',
    TOOLTIP_BID_GOOD_FOR: 'How long the bid will still be valid after its creation.',
    TOOLTIP_ROUTE_CALLS_FOR_STALE_BIDS: 'What to do in case a call comes in after the period set in the "Bid Good For" field.',
    TOOLTIP_MAXIMUM_REQUESTS: 'Maximum requests that will be handled in a specific period. Changes on this setting may take a few minutes to apply.',
    TOOLTIP_OVERRIDE_DYNAMIC_INBOUND_CALLS_SETTINGS: 'Override the Real Time Bidding Settings set at the campaign level.',
    TOOLTIP_OVERRIDE_RATE_LIMIT: 'Override the Rate Limit Settings set at the campaign level.',
    TOOLTIP_OVERRIDE_DEFAULT_BID_SETTINGS: 'Override the Default Bid Settings set at the campaign level.',
    TOOLTIP_OVERRIDE_DEFAULT_PASSTHROUGH_SETTINGS: 'Override the Default Pass Through Settings set at the campaign level.',
    TOOLTIP_ENABLE_PASSTHROUGH_SETTINGS: 'Enables pass through for all the publishers in this campaign.',
    TOOLTIP_OVERRIDE_BID_ADJUSTMENTS: 'Override the Bid Adjustments set at the campaign level.',
    TOOLTIP_BASE_BID_AMOUNT: 'Bid value before being adjusted.',
    TOOLTIP_MAX_BID: 'Maximum bid amount regardless of any adjustments.',
    TOOLTIP_MIN_BID: 'Minimum bid amount regardless of any adjustments.',
    TOOLTIP_PAYOUT_ON: 'When the selected conversion event happens, the publisher will be credited.',
    TOOLTIP_START_TIMER_EVENT: 'The point in the call where we start the call length timer for the conversion.',
    TOOLTIP_LENGTH: 'The amount of time in seconds that must pass before a payout will be credited to a publisher.',
    TOOLTIP_DUPLICATE_PAYOUTS: 'When enabled, publishers will be credited on duplicate or repeat calls. When disabled, this option will prevent publishers from being paid multiple times by making a $0 bid if the CallerID was provided. If the CallerID is not provided but the call is a duplicate call, the promised bid will not be credited. Time Limit allows for duplicate payouts after a specific length of time.',
    TOOLTIP_PAYOUT_HOURS: 'The hours of operation where your publisher should be credited for calls.',
    TOOLTIP_LIMIT_PAYOUT: 'Set caps to payouts based on calls, amount, and concurrency',
    TOOLTIP_BID_MARGIN_PERCENTAGE: 'The margin percentage reserved for you between buyer and seller.',
    TOOLTIP_BID_MARGIN_AMOUNT: 'The margin in dollars that is reserved for you between buyer and seller.',
    TOOLTIP_MIN_BID_MARGIN_PERCENTAGE_AFTER_ADJUSTMENTS: 'The minimum margin percentage reserved for you between buyer and seller after applying bid modifiers.',
    TOOLTIP_MIN_BID_MARGIN_AMOUNT_AFTER_ADJUSTMENTS: 'The minimum margin in dollars that is reserved for you between buyer and seller after applying bid modifiers.',
    TOOLTIP_MIN_BID_DURATION_SELECTION: 'Select how the minimum call length for a bid to be paid out is calculated. If Use Target Duration is selected then the duration will match the duration received from the winning target. If Override is selected the bid duration will always be a set value. If Adjust is selected then the duration from target will be modified by the given amount.',
    TOOLTIP_MIN_BID_STATIC: 'Static minimum duration that will be returned to the bidders.',
    TOOLTIP_MIN_BID_ADJUST: 'The minimum payout duration can be adjusted by adding seconds to the buyer\'s returned duration.',
    TOOLTIP_ALLOW_BIDS_AT_LOSS: 'Enabling this will allow you to lose money on a bid. Do not enable this feature unless you specifically want a loss as a potential outcome.',
    ERROR_GREATER_THAN_OR_EQUAL: 'The value must be greater than or equal to zero',
    ERROR_BASE_BID_AMOUNT: 'The Base Bid Amount must be greater or equal to zero',
    ERROR_MAX_BID_AMOUNT: 'The Max Bid Amount must be greater than zero',
    ERROR_MIN_BID_AMOUNT: 'The Min Bid Amount must be greater than zero',
    ERROR_BID_EXPIRATION: 'The Bid Good For time must be a number between 0 and 3600. For a higher expiration time, enable Require Caller ID.',
    ERROR_BID_STATIC_ADJUSTMENT_AMOUNT: 'The override must be a value greater than zero',
    ERROR_BID_ADJUSTED_ADJUSTMENT_AMOUNT: 'The adjustment must be a value greater than zero',
    ERROR_BID_EXPIRATION_WITH_CID: 'The Bid Good For time must be a number greater or equal to zero.',
    ERROR_CUSTOM_SCORING_JSON: 'Valid JSON Required',
    MULTIPLE_TOGGLE_OPTIONS_REJECT: 'Reject',
    MULTIPLE_TOGGLE_OPTIONS_ROUTE_NORMALLY: 'Route Normally',
    MULTIPLE_TOGGLE_OPTIONS_INCOMING: 'Incoming',
    MULTIPLE_TOGGLE_OPTIONS_DIAL: 'Dial',
    MULTIPLE_TOGGLE_OPTIONS_CONNECT: 'Connect',
    MULTIPLE_TOGGLE_OPTIONS_DISABLED: 'Disabled',
    MULTIPLE_TOGGLE_OPTIONS_ENABLED: 'Enabled',
    MULTIPLE_TOGGLE_OPTIONS_TIME_LIMIT: 'Time Limit',
    MULTIPLE_TOGGLE_OPTIONS_REQUIRED: 'Required',
    MULTIPLE_TOGGLE_OPTIONS_CLAIM: 'Claim',
    MULTIPLE_TOGGLE_OPTIONS_VERIFY: 'Verify',
    DROPDOWN_BID_DURATION_OPTION_DEFAULT: 'Use target duration',
    DROPDOWN_BID_DURATION_OPTION_STATIC: 'Override target duration',
    DROPDOWN_BID_DURATION_OPTION_ADJUSTED: 'Adjust from target duration',
    BUTTON_SAVE: 'Save',
    SECONDS_LABEL: 'seconds',
    CUSTOM_BID_DURATION_WARNING: 'The minimum call duration setting was updated through the API and is not able to be displayed. The current settings will be preserved unless a new option is selected.',
    EDIT_BID_MODIFIER: 'Edit bid modifier',
    BUTTON_RUN_REQUEST: 'Run Request',
    REVERT: 'Revert Unsaved Changes',
    MESSAGE_CUSTOM_SCORING_INITIAL: 'Run the request to fetch a response and configure the custom scoring parse settings.',
    MESSAGE_CUSTOM_SCORING_SUCCESS: 'Add parse settings to complete the custom scoring configuration.',
    MESSAGE_CUSTOM_SCORING_FAILED: 'Failed request. Verify the URL and request settings are correct.',
    MESSAGE_CUSTOM_SCORING_V1: 'This campaign has an API version of Custom Scoring that is not compatible with the UI. The saved configuration will still function as expected. If you want control over this configuration in the UI, please reach out to our customer support team so they can process the update.',
    LABEL_VIEW_RESPONSE: 'View Response',
    LABEL_VIEW_ERROR: 'View Error',
    HEADING_SAMPLE_TOKENS: 'Sample Token Values',
    LIMIT_RTB_PAYOUT_LABEL: 'Limit RTB Payout'
  }
};